import { Chip } from "@mui/material";
import { useEffect, useState } from "react";
import { addFilterToLocalStorage } from "../../common/EntitiesManagement";

export default function FilterBox({
  filterItemName,
  filterData,
  setFilterData,
  defaultFiltering,
  saveFilter,
  hiddenFilterNames,
}) {
  const [filterInformation, setFilterInformation] = useState(filterData);

  const isHidden = (filter) =>
    Array.isArray(hiddenFilterNames) && hiddenFilterNames.includes(filter?.Name);

  const visibleFilters = (filterInformation ?? []).filter((f) => !isHidden(f));

  const handleRemoveButton = (itemToRemove) => {
    const index = filterInformation.indexOf(itemToRemove);
    if (index >= 0) {
      filterInformation.splice(index, 1);

      if (filterInformation.length === 0) {
        setFilterData(defaultFiltering);

        if (saveFilter) {
          addFilterToLocalStorage(filterItemName, defaultFiltering);
        }
      } else {
        setFilterData([...filterInformation]);

        if (saveFilter) {
          addFilterToLocalStorage(filterItemName, [...filterInformation]);
        }
      }
    }
  };

  useEffect(() => {
    setFilterInformation(filterData);
  }, [filterData]);

  return (
    <div>
      {visibleFilters?.length > 0 ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {visibleFilters.map((filter) => (
              <Chip
                sx={{
                  "& .MuiChip-deleteIcon": {
                    color: "var(--app-fg, #ffffff)",
                  },
                  "& .MuiChip-deleteIcon:hover": {
                    color: "var(--app-fg, #ffffff)",
                  },
                }}
                style={{
                  margin: "2px",
                  fontSize: "12px",
                  fontWeight: 400,
                  backgroundColor: "var(--app-bg, #10366E)",
                  color: "var(--app-fg, #ffffff)",
                  whiteSpace: "pre-wrap",
                }}
                key={filter.Name}
                label={`${filter.FriendlyName} ${
                  !!filter.Value ? `: ${filter.Value}` : ""
                }`}
                onDelete={() => {
                  handleRemoveButton(filter);
                }}
              />
            ))}
        </div>
      ) : (
        <div />
      )}
    </div>
  );
}
